module.exports = __webpack_public_path__ + "static/img/home_new6.2f0875a9.jpg";